import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "./ConsultationModal.css";
import { API_BASE_URL } from "../config";

const ConsultationModal = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  // Prevent background scroll
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/consultation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      if (data.success) {
        alert("✅ Consultation request sent successfully!");
        onClose();
      } else {
        alert("⚠ Something went wrong");
      }
    } catch (err) {
      alert("⚠ Server error");
    } finally {
      setLoading(false);
    }
  };

  return createPortal(
    <div className="cs-modal-overlay" onClick={onClose}>
      <div className="cs-modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="cs-close-btn" onClick={onClose}>&times;</button>
        
        <div className="cs-layout">
          {/* 1. VISUAL SIDE */}
          <div className="cs-visual">
            <div className="cs-badge">Expert Consultation</div>
            <div className="cs-visual-content">
              <div className="cs-icon-box">🛰️</div>
              <h3>Mission <br/>Intelligence</h3>
              <p>Get direct access to our senior UAV engineers and deployment specialists.</p>
              <ul className="cs-benefits">
                <li>• Technical Strategy</li>
                <li>• Fleet Optimization</li>
                <li>• Regulatory Guidance</li>
              </ul>
            </div>
            <div className="cs-footer-tag">FLYTUTOR Aerospace</div>
          </div>

          {/* 2. FORM SIDE */}
          <div className="cs-form-side">
            <h2 className="cs-title">Book Free Consultation</h2>
            <p className="cs-subtitle">Schedule a technical briefing with our experts.</p>

            <form onSubmit={handleSubmit} className="cs-main-form">
              <div className="cs-form-grid">
                <div className="cs-input-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    name="name"
                    required
                    placeholder="John Doe"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="cs-input-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="john@enterprise.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="cs-input-group full">
                  <label>Contact Number</label>
                  <input
                    type="tel"
                    name="number"
                    required
                    placeholder="+91 XXXXX XXXXX"
                    value={formData.number}
                    onChange={handleChange}
                  />
                </div>

                <div className="cs-input-group full">
                  <label>Inquiry Details (Optional)</label>
                  <textarea
                    name="message"
                    placeholder="Briefly describe your requirements or challenges..."
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </div>

              <button type="submit" className="cs-submit-btn" disabled={loading}>
                {loading ? "Transmitting..." : "Schedule My Briefing →"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConsultationModal;
